import React, { FC, useContext } from 'react';
import { UserContext } from '../../user/UserContext';
import { useRestrictedModal } from '../../components/modal/useRestrictedModal';
import { MaterialIcon } from '../../components/material-icon/MaterialIcon';
import styles from './hide_wrapper.module.scss';

type Props = {
  source: string;
};

export const HideWrapper: FC<Props> = ({ children, source }) => {
  const { accessPremium } = useContext(UserContext);
  const { openRestrictedModal } = useRestrictedModal();
  return accessPremium ? (
    <>{children}</>
  ) : (
    <div className={styles.hide}>
      <button
        className={styles.hidden}
        onClick={() => openRestrictedModal({ source })}
        type="button"
      >
        <MaterialIcon name="lock" className={styles.locked} />
      </button>
      {children}
    </div>
  );
};
